import React, { useMemo, type MutableRefObject } from 'react';

import { ConjugueTable } from '../../../../components';
import SharedInsuredFormSection, {
  type SharedInsuredFormSectionLabels,
} from '../../../../components/pagesComponents/vidaPageComponents/SharedInsuredFormSection';
import type { NewInsuredFormValues } from '../../../../types/vida/cadastralMaintenance/newInsuredFormTypes';
import type { PersonFormSection, PersonFormSectionControl } from '../../../../types/vida/cadastralMaintenance/personFormTypes';
import type { ConjugueTableItem } from '../../../../types/vida/table/conjugueTableType';

const conjugueFormLabels: SharedInsuredFormSectionLabels = {
  personDataButton: 'Dados do Cônjuge',
  personDataAriaLabel: 'Exibir dados do cônjuge',
  personDataTitle: 'Dados do Cônjuge',
  personAddressButton: 'Endereço do Cônjuge',
  personAddressAriaLabel: 'Exibir endereço do cônjuge',
  personAddressTitle: 'Endereço do Cônjuge',
  insuranceInfoButton: 'Dados Empresariais',
  insuranceInfoAriaLabel: 'Exibir dados empresariais do cônjuge',
  insuranceInfoTitle: 'Dados Empresariais',
};

type ConjuguePanelSectionProps = {
  conjugueValues: NewInsuredFormValues | null;
  isAdding: boolean;
  canAdd: boolean;
  isSaving?: boolean;
  sectionControlRef?: MutableRefObject<PersonFormSectionControl | null>;
  onActiveSectionChange?: (section: PersonFormSection) => void;
  onAdd: () => void;
  onEdit: () => void;
  onValuesChange?: (values: NewInsuredFormValues) => void;
  onValidityChange?: (isValid: boolean) => void;
};

const mapConjugueToTableRows = (values: NewInsuredFormValues | null): ConjugueTableItem[] => {
  if (!values) {
    return [];
  }

  return [{
    id: 'conjugue',
    nome: values.nome,
    cpf: values.cpf,
    dataNascimento: values.dataNascimento,
    source: values,
  }];
};

const ConjuguePanelSection: React.FC<ConjuguePanelSectionProps> = ({
  conjugueValues,
  isAdding,
  canAdd,
  isSaving = false,
  sectionControlRef,
  onActiveSectionChange,
  onAdd,
  onEdit,
  onValuesChange,
  onValidityChange,
}) => {
  const conjugueRows = useMemo(
    () => mapConjugueToTableRows(conjugueValues),
    [conjugueValues],
  );

  if (isAdding) {
    return (
      <div
        className="bsds-mt-16"
        role="region"
        aria-label="Cadastro de cônjuge"
      >
        <SharedInsuredFormSection
          labels={conjugueFormLabels}
          readOnly={!canAdd || isSaving}
          showDataCadastro
          initialValues={conjugueValues ?? undefined}
          onValidityChange={onValidityChange}
          onValuesChange={onValuesChange}
          sectionControlRef={sectionControlRef}
          onActiveSectionChange={onActiveSectionChange}
        />
      </div>
    );
  }

  return (
    <div className="bsds-mt-16" role="region" aria-label="Lista de cônjuge do segurado">
      <ConjugueTable
        rows={conjugueRows}
        onEdit={() => onEdit()}
        onAdd={onAdd}
        canEdit={canAdd}
        canAdd={canAdd && conjugueRows.length === 0}
      />
    </div>
  );
};

export default ConjuguePanelSection;
